import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const NBitAdderRippleCLA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="N-bit Adder (Ripple carry Adder, Carry look ahead adder)"
    videos={[
      "https://www.youtube.com/embed/b70ZQwci5sY?si=8NNBuNe2OEm0XO2X",
      "https://www.youtube.com/embed/SQKdnxysXnw?si=M3Wc1vF9RwbfDoxA",
      "https://www.youtube.com/embed/tewn0i8DDgw?si=XmTkLc7ykB3XntDF",
      "https://www.youtube.com/embed/BcGJQ0RigjE?si=eg7e_Kp31lG_2zjA"
    ]}
    takeaways={[]}
    questions={[
      "1) Develop a Verilog code for parallel adder using GATE Level Modelling",
      "2) Write the Verilog Code for a 5-Bit Carry Look Ahead Adder Circuit using Behavioral Model with Test Bench",
      "3) Design a 4 bit Ripple Carry Adder using full adders and write the Gate Level Verilog Code using module instantiation"
    ]}
    exampleVideos={[]}
  />
);
}

export default NBitAdderRippleCLA;
